import { DefinedMessages } from '../types/types';

export const messages: DefinedMessages = {
  createinvoicingheader: {
    id: 'invoicing.card.create.header',
    defaultMessage: 'Invoicing',
  },
  createinvoicingtext: {
    id: 'invoicing.card.create.description',
    defaultMessage: 'Invoicing',
  },
  allinvoicesheader: {
    id: 'invoicing.card.all.header',
    defaultMessage: 'Invoicing',
  },
  allinvoicestext: {
    id: 'invoicing.card.all.description',
    defaultMessage: 'Invoicing',
  },
  eventsource: {
    id: 'create.invoicing.eventsource',
    defaultMessage: 'Event source',
  },
  deliveryMethod: {
    id: 'invoicing.fennoa.delivery_method',
    defaultMessage: 'Delivery method',
  },
  event: {
    id: 'create.invoicing.event',
    defaultMessage: 'Event',
  },
  multiple: {
    id: 'create.invoicing.multiple',
    defaultMessage: 'Invoice multiple',
  },
  hardcoded: {
    id: 'create.invoicing.hardcoded.switch',
    defaultMessage: 'Hardcoded',
  },
  destination: {
    id: 'create.invoicing.destination',
    defaultMessage: 'Invoice destination',
  },
  receiverstab: {
    id: 'invoicing.tabs.receivers',
    defaultMessage: 'Receivers',
  },
  mappingtab: {
    id: 'invoicing.tabs.mapping',
    defaultMessage: 'Mapping',
  },
  sendingtab: {
    id: 'invoicing.tabs.send',
    defaultMessage: 'Sending',
  },
  prevheader: {
    id: 'preview.invoicing.header',
    defaultMessage: 'Preview',
  },
  prevdescription: {
    id: 'preview.invoicing.description',
    defaultMessage: 'Creating invoices',
  },
  prevrow: {
    id: 'preview.invoicing.row',
    defaultMessage: 'Row',
  },
  prevprev: {
    id: 'preview.invoicing.prev',
    defaultMessage: 'Previous',
  },
  prevnext: {
    id: 'preview.invoicing.next',
    defaultMessage: 'Next',
  },
  prevnoreceivers: {
    id: 'preview.invoicing.noreceivers',
    defaultMessage: 'No receivers',
  },
  errorsmissing: {
    id: 'errors.invoicing.missing',
    defaultMessage: 'Missing required information from mapping',
  },
  errorsok: {
    id: 'errors.invoicing.ok',
    defaultMessage: 'Everything OK',
  },
  errorsvalidation: {
    id: 'errors.invoicing.validation',
    defaultMessage: 'Validation errors',
  },
  errorsvalok: {
    id: 'errors.invoicing.valok',
    defaultMessage: 'No validation errors',
  },
  errorsdesciption: {
    id: 'errors.invoicing.description',
    defaultMessage: 'Cannot send before above errors are handled',
  },
  errorsdescriptionwarnings: {
    id: 'errors.invoicing.descriptionwarnings',
    defaultMessage: 'Can send but check warnings',
  },
  sendbutton: {
    id: 'send.invoicing.button',
    defaultMessage: 'Send',
  },
  csvupload: {
    id: 'cert.create.csvupload',
    defaultMessage: 'Drag here or click to upload',
  },
  csvheaders: {
    id: 'cert.create.csvheaders',
    defaultMessage: 'Data has headers',
  },
};
